import React, { useEffect, useState } from 'react';
import { Center, Icon, InnerSmall, LabelSmall, LabelTitle, LineSmall, Paragraph, Row } from 'meitav-uikit';
import { UmbracoStep } from 'components/Umbraco/UmbracoContext';
import { Parser } from 'html-to-react';
import utils from 'utils';
import "./step99.scss";
import { isMobile } from 'react-device-detect';
import { saveModel } from 'utils/Functions';

const { UmbracoUtills, rest } = utils;

export default function Step99({
  resource,
  model,
  dataList,
}) {

  const p = new Parser();
  const resourceStep = UmbracoStep(resource, `ThirdSub4Step`);
  useEffect(() => {
    runDataLayer();
  }, []);

  const runDataLayer = async () => {
    let MediniyutHashkaa_ProcessID;
    let processID;

    MediniyutHashkaa_ProcessID = await rest
      .get(`/api/Manager/GetMediniyutHashkaaByProcessID`)
      .then(async () => {

        processID = await rest.get(`/api/Manager/GetProcessId`);  //, {

      });
    let depositSum = model?.paymentDetails?.depositSum;

    window.dataLayer.push({
      event: "transaction completed",
      ecommerce: {
        purchase: {
          actionField: {
            id: processID?.data, // יש להטמיע את מזהה הגולש במערכת כפי שיופיע ב URL
            affiliation: "ניהול תיקים דיגיטלי",
            revenue: depositSum, // יש להטמיע את הסכום אותו הגולש הצהיר שאותו ישקיע השקעה ראשונית
            tax: "0",
            shipping: 0,
          },
          products: [
            {
              name: `תיק השקעות${MediniyutHashkaa_ProcessID?.data?.MediniyutHashkaa}`,
              id: `pm100${MediniyutHashkaa_ProcessID?.data?.MediniyutHashkaa}`, // יש לקבוע לכל רמת סיכון מספר שמכיל 4 ספרות ומתחיל בספרה **1
              price: depositSum, // יש להזין את ערך ההשקעה הראשונית שהגולש הצהיר עליו
              category: MediniyutHashkaa_ProcessID?.data?.MediniyutHashkaa, // יש להזין את רמת הסיכון שנקבעה לגולש
              variant: "investment purpose", // יש להזין את מטרת ההשקעה שעליה הצהיר הגולש
              quantity: 1,
            },
          ],
        },
      },
    });
    window.dataLayer.push({
      event: "PM - Finish",
      eventInfo: {
        action_screen: "/JoinPersonalDetails",
        process_level: "סיום תהליך",
        action_name: "סיום תהליך פתיחת תיק השקעות דיגיטלי",
      },
    });
  };

  return (
    <div className="stepEnd">
      <Center>
        <InnerSmall>
          <div class="mobileLogo">
            {isMobile && <Icon src={`${import.meta.env.VITE_REACT_APP_IMAGE_URL || window.location.origin}/${UmbracoUtills.getValueByKey(resourceStep, "logoMobile")}`} />}
          </div>
          <Row className='stepBody'>
            <Row>
              {!isMobile && <Icon src={`${import.meta.env.VITE_REACT_APP_IMAGE_URL || window.location.origin}/${UmbracoUtills.getValueByKey(resourceStep, "logo")}`} />}
              <>
                <Icon src={`${import.meta.env.VITE_REACT_APP_IMAGE_URL || window.location.origin}/${UmbracoUtills.getValueByKey(resourceStep, "image")}`} />
                <LabelTitle align='center'>{p.parse(UmbracoUtills.getValueByKey(resourceStep, "title"))}</LabelTitle>
                <hr className='pink' />
                <Paragraph>{p.parse(UmbracoUtills.getValueByKey(resourceStep, "subTitle"))}</Paragraph>
              </>
            </Row>
          </Row>
          <Row className='stepFooter'>
            <LabelSmall>{UmbracoUtills.getValueByKey(resourceStep, "footerText")}</LabelSmall>
            <LineSmall>
              <LabelSmall>{UmbracoUtills.getValueByKey(resourceStep, "phone")}</LabelSmall>
              <LabelSmall addClass='error'>{UmbracoUtills.getValueByKey(resourceStep, "phoneNumber")}</LabelSmall>
              <LabelSmall>|</LabelSmall>
              <LabelSmall>{UmbracoUtills.getValueByKey(resourceStep, "email")}</LabelSmall>
              <LabelSmall addClass='error'>{UmbracoUtills.getValueByKey(resourceStep, "emailAddress")}</LabelSmall>
            </LineSmall>
          </Row>
        </InnerSmall>
      </Center>
    </div>
  );
}
